// TO DO - update routes once determined
import { RouteConfig } from 'vue-router'
import AdminLayout from '@/views/layouts/AdminLayout.vue'
import Learn from '@/views/learn/Learn.vue'

export default {
  path: '/learn',
  component: AdminLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '',
      name: 'Learn',
      component: Learn
    }
  ]
} as RouteConfig
